export { clientNamespaces } from './client-namespaces';
